// extracted by mini-css-extract-plugin
export default {"ignoreLabelOuter":"advanced-module__Thmwt","ignoreLabelHeader":"advanced-module__C02v4","ignoreListMessage":"advanced-module__tTXqu","ignoreListInput":"advanced-module__TBhYR"};